// Don't rename values. These values come from nebula.
export const FEATURE_SELECTION_MODES = Object.freeze({
  POLYGON: 'DrawPolygonMode',
  RECTANGLE: 'DrawRectangleMode',
  CIRCLE: 'DrawCircleFromCenterMode',
  LASSO_TOOL: 'DrawPolygonByDraggingMode'
});

export const EDIT_MODES = Object.freeze({
  EDIT: 'edit'
});

export const MASK_ID = 'feature_selection_mask';
